import { useTranslation } from "react-i18next";
import { useState } from "react";
import InsuranceIcon from "../../../../../assets/icons/insurance.svg?react";
import { OptionsInsuranceModal } from "./optionsInsuranceModal";

type InsuranceProps = {
  insurance: number;
};

export const ParameterInsurance = ({ insurance }: InsuranceProps) => {
  const { t } = useTranslation("boParameters");
  const [showInsuranceModal, setShowInsuranceModal] = useState(false);

  return (
    <div className="flex w-full max-w-[600px] flex-col gap-2 rounded-xl border border-gray-200 bg-white p-6">
      <div className="flex flex-row justify-between gap-4">
        <div className="flex w-fit flex-row items-center gap-4">
          <InsuranceIcon className="text-black" width={24} height={24} />
          <h3 className="text-lg font-semibold text-black">{t("insuranceOption.title")}</h3>
        </div>
        <div className="flex flex-row items-center gap-4">
          <button
            type="button"
            onClick={() => setShowInsuranceModal(true)}
            className="bg-brand50 text-brand700 h-fit w-fit rounded-lg px-4 py-2 text-sm font-semibold hover:bg-blue-100 focus:outline-hidden"
          >
            {t("insuranceOption.edit")}
          </button>
        </div>
      </div>
      <div className="flex flex-row items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
        <p className="text-xs font-medium text-gray-500">{t("insuranceOption.defaultRate")}</p>
        <p className="text-sm font-medium text-gray-900">{insurance}%</p>
      </div>
      {showInsuranceModal && (
        <OptionsInsuranceModal
          closeModal={() => setShowInsuranceModal(false)}
          title={t("insuranceOption.modalTitle")}
          insurance={insurance}
        />
      )}
    </div>
  );
};
